export default __webpack_public_path__ + "static/media/BaseballBat_2.fef62b45.png";